// Herkese açık menü, panelin kimlik/PWA/istasyon başlangıcını indirmez.
// Yönetim yolları /menu/:slug ile aynı öneki paylaşır; ayrı girişe düşmemelidir.
const segment = location.pathname.match(/^\/menu\/([^/]+)\/?$/)?.[1];
const panelMenuPaths = new Set(['bulk', 'modifiers', 'prices', 'tablo', 'ceviriler']);
/** Paket indirilemedi (çoğu zaman eski kabuk HTML'i yeni dağıtımın paketini istiyor, 404): servis işçisi ve önbellekler
 *  silinip sayfa bir kez taze yüklenir; ikinci kez olursa kullanıcıya düğme gösterilir. */
const repairOnce = async (): Promise<boolean> => {
  try { if (sessionStorage.getItem('bg.repaired') === '1') return false; sessionStorage.setItem('bg.repaired', '1'); } catch { return false; }
  try { for (const r of await navigator.serviceWorker?.getRegistrations() ?? []) await r.unregister(); } catch { /* yok */ }
  try { for (const k of await caches.keys()) await caches.delete(k); } catch { /* yok */ }
  location.replace(location.pathname + location.search + (location.search ? '&' : '?') + 'r=' + Date.now());
  return true;
};
const failed = async () => {
  if (navigator.onLine && await repairOnce()) return;
  const root = document.getElementById('root');
  if (!root) return;
  const message = document.createElement('p');
  message.textContent = 'Sayfa yüklenemedi. Bağlantınızı kontrol edip yeniden deneyin.';
  const retry = document.createElement('button');
  retry.textContent = 'Yeniden dene';
  retry.onclick = () => location.reload();
  root.replaceChildren(message, retry);
};
if (segment && !panelMenuPaths.has(segment)) {
  void import('./menu-entry').catch(failed);
} else {
  void import('./panel-entry').catch(failed);
}
